import { Grid } from "@mui/material";

import { Text } from "../Text/Text";
import "./Options.scss";

export interface IOption {
  id: any;
  content: string | JSX.Element;
}
interface Props {
  id: any;
  handleChange: (any) => void;
  options: Array<IOption>;
  error?: string;
}
export const Options = ({ id, handleChange, options, error = "" }: Props) => (
  <>
    <div className="options">
      {options.map((option) => {
        return (
          <div
            key={option.id}
            className="option__item"
            onClick={() => handleChange(option.id)}
          >
            <div
              className={`option ${
                id === option.id
                  ? error
                    ? "option__error"
                    : "option__chosen"
                  : ""
              }`}
            >
              {typeof option.content === "string" ? (
                <Text text={option.content} />
              ) : (
                <>{option.content}</>
              )}
            </div>
          </div>
        );
      })}
    </div>
    {error && (
      <Grid item>
        <Text className="option__error-message" text={error} />
      </Grid>
    )}
  </>
);
